<script>
  import { _ } from 'svelte-i18n'
  import Modal from '../../elements/Modal.svelte'
  import Blink from '../../elements/Blink.svelte'

  let modal_id = 'activatingAccount'
</script>

<Modal id={modal_id} persistent={true}>
  <span slot="header">
    {$_('modals.activatingAccount.title')}
  </span>
  <span class="content" slot="content">
    <Blink>
      {$_('modals.activatingAccount.content')}
    </Blink>
  </span>
</Modal>

<style>
  .content {
    display: inline-block;
    margin-bottom: 1rem;
  }
</style>